<template>
  <div class="sign-address-map"
       v-loading="loading"
       element-loading-text="地图加载中，请稍等...">
    <MapModal v-if="mapConfig.mapKey && hasCoordinates"
              ref="mapModal"
              embedded
              :height="520"
              :location="rowData.address || rowData.name || ''"
              :map-location="coordinates"
              :map-key="mapConfig.mapKey"
              :circle-radius="mapRadius">
    </MapModal>
    <Hint v-else-if="!loading"
          type="empty">
      <div>该地址没有地图坐标</div>
    </Hint>
  </div>
</template>

<script>
import Hint from '../../../../../../../../elements/Hint'
import MapModal from '../../../../../../../../widgets/tencent/MapModal'

export default {
  name: 'SignAddressMap',
  components: {
    Hint,
    MapModal
  },
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      mapConfig: {
        mapKey: '',
        maxSignDistance: 500
      }
    }
  },
  computed: {
    coordinates () {
      return (this.rowData.tencentMapLocation || '').trim()
    },
    hasCoordinates () {
      return Boolean(this.coordinates)
    },
    mapRadius () {
      return Number(this.mapConfig.maxSignDistance) || 500
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.openMap()
      }
    }
  },
  mounted () {
    this.openMap()
  },
  methods: {
    openMap () {
      if (!this.hasCoordinates) {
        return
      }
      if (this.mapConfig.mapKey) {
        this.showMap()
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      this.$ajax({
        url: '/support/thirdparty/tencent/map/queryTencentMapBaiscConfig',
        method: 'post'
      }).then(response => {
        if (!response.data || response.data.responseCode !== 'SUCCESS' || !response.data.mapKey) {
          throw new Error(response.data && response.data.message
            ? response.data.message
            : '地图配置加载失败')
        }
        this.mapConfig.mapKey = response.data.mapKey
        this.mapConfig.maxSignDistance = response.data.maxSignDistance || 500
        this.showMap()
      }).catch(error => {
        this.$message.warning(error.message || '地图配置加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    showMap () {
      this.$nextTick(() => {
        if (this.$refs.mapModal) {
          this.$refs.mapModal.show()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-address-map {
  min-height: 520px;

  .layout-hint {
    height: 520px;
  }
}
</style>
